import { Dropdown } from "primereact/dropdown";
import * as React from "react";
import { OptionsConstants } from "../../../models/constants/options.constants";
import "./PrwcLanguage.scss";

const PrwcLanguage = (props: any) => {
  const IMG = (imgName: string) => {
    return require(`./../../../../../../../assets/icons/flags/${imgName}.svg`)?.default;
  };

  const selectedOptionTemplate = (option: any, props: any) => {
    if (option) {
      return (
        <div className="flex items-center">
          <img
            alt={option.viewValue}
            src={IMG(option.flag.toLowerCase())}
            className="w-5 mx-2 align-middle"
          />
          <div>{option.viewValue}</div>
        </div>
      );
    }

    return <span>{props.placeholder || "dummy Value"}</span>;
  };

  const optionTemplate = (option: any) => {
    return (
      <div className="flex items-center">
        <img
          alt={option.viewValue}
          src={IMG(option.flag.toLowerCase())}
          className="w-5 mx-2 align-middle"
        />
        <div>{option.viewValue}</div>
      </div>
    );
  };

  return (
    <div>
      <Dropdown
        optionLabel="viewValue"
        optionValue="value"
        className="p-inputtext-sm w-36 prwc-language"
        value={props.language}
        options={OptionsConstants.Languages}
        valueTemplate={selectedOptionTemplate}
        itemTemplate={optionTemplate}
        placeholder={""}
        onChange={(e) => {
          props.onLanguageChange(e.target.value);
        }}
      />
    </div>
  );
};

export default PrwcLanguage;
